export default {
  sections: {
    setup_fee: {
      title: 'Costuri de configurare',
      description: 'Costuri de configurare de la {{amount}} – în loc de 1.000+',
    },
  },
  labels: {
    month: 'Lună (NET)',
    one_time_fee: 'Taxă unică',
    more_options: 'Mai multe opțiuni',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Propria ta aplicație în App Store & Google Play',
    push_notifications: 'Notificări push pentru oferte',
    loyalty: 'Fidelizarea clienților prin programe de loialitate',
    offline_orders: 'Comenzi offline posibile',
    individual_design: 'Design individual al aplicației',
  },
  setup_fee_options: {
    150: 'Configurare standard',
    75: 'Redus',
    0: 'Fără costuri de creare',
  },
  feedback: {
    contract_signed_already: {
      title: 'Contractul este deja semnat',
      description: 'Contactați suportul tehnic dacă doriți să efectuați modificări',
    },
  },
};
